import { lazy, Lazy } from 'utility/Lazy';

export class MultiScreenSession {
    private connection: Lazy<PresentationConnection>;

    get state() {
        return this.rawConnection.state;
    }

    get presentationId() {
        return this.rawConnection.id;
    }

    private _terminated = false;
    get terminated() { return this._terminated; }

    constructor(private readonly rawConnection: PresentationConnection, onMessage?: (msg: string) => void, onClose?: (e: PresentationConnectionCloseEvent) => void) {
        this.connection = lazy(new Promise<PresentationConnection>((resolve, reject) => {
            switch (rawConnection.state) {
                case 'connected':
                    resolve(rawConnection);
                    break;
                case 'connecting':
                    rawConnection.addEventListener('connect', () => resolve(rawConnection));
                    break;
                default:
                    reject(new Error(`connection ${rawConnection.id} is ${rawConnection.state}`));
            }
        }));

        rawConnection.addEventListener('close', e => {
            if (onClose) onClose(e);
            this.connection.clear();
        });

        rawConnection.addEventListener('terminate', () => {
            this.connection.clear();
            this._terminated = true;
        });

        rawConnection.addEventListener('message', ev => {
            if (onMessage) onMessage(ev.data);
        });
    }

    async send(message: string | Blob | ArrayLike<unknown>) {
        const connection = await this.connection.get();
        connection.send(message);
    }

    disconnect() {
        this.rawConnection.close();
    }

    terminate() {
        this.rawConnection.terminate();
    }
}
